<template>
  <div class="employee-manage-container">
    <div class="page-header">
      <div class="header-left">
        <i class="el-icon-arrow-left" @click="goBack"></i>
        <span class="page-title">考勤汇总报表</span>
      </div>
      <el-button type="primary" size="small" @click="handleExport">
        <i class="el-icon-download"></i> 导出月报
      </el-button>
    </div>

    <div class="search-bar">
      <el-date-picker
        v-model="searchForm.yearMonth"
        type="month"
        placeholder="统计月份"
        value-format="yyyy-MM"
        style="width: 150px"
        @change="handleSearch"
      />
      <el-select v-model="searchForm.departmentId" placeholder="全部部门" clearable style="width: 150px; margin-left: 10px;" @change="handleSearch">
        <el-option label="全部部门" value="" />
        <el-option v-for="item in departmentList" :key="item.id" :label="item.name" :value="item.id" />
      </el-select>
      <el-select v-model="searchForm.userRole" placeholder="全部角色" clearable style="width: 150px; margin-left: 10px;" @change="handleSearch">
        <el-option label="全部角色" value="" />
        <el-option label="内勤" value="STAFF" />
        <el-option label="教练" value="COACH" />
        <el-option label="司机" value="DRIVER" />
        <el-option label="业务员" value="SALES" />
        <el-option label="财务" value="FINANCE" />
        <el-option label="人事" value="HR" />
      </el-select>
      <el-input placeholder="姓名/工号" v-model="searchForm.keyword" style="width: 150px; margin-left: 10px;" clearable>
        <i slot="prefix" class="el-icon-search"></i>
      </el-input>
    </div>

    <div class="content-wrapper">
    <!-- 月度汇总统计 -->
    <el-card class="stats-card">
      <div slot="header">
        <span>月度汇总统计</span>
        <span class="subtitle">{{ searchForm.yearMonth }} 考勤汇总</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="4">
          <div class="summary-item">
            <div class="summary-value">{{ summaryStats.totalEmployees }}</div>
            <div class="summary-label">在职员工</div>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="summary-item">
            <div class="summary-value normal">{{ summaryStats.normalDays }}</div>
            <div class="summary-label">正常天数</div>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="summary-item">
            <div class="summary-value warning">{{ summaryStats.lateDays }}</div>
            <div class="summary-label">迟到次数</div>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="summary-item">
            <div class="summary-value warning">{{ summaryStats.earlyDays }}</div>
            <div class="summary-label">早退次数</div>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="summary-item">
            <div class="summary-value danger">{{ summaryStats.absentDays }}</div>
            <div class="summary-label">缺卡次数</div>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="summary-item">
            <div class="summary-value info">{{ summaryStats.leaveDays }}</div>
            <div class="summary-label">请假天数</div>
          </div>
        </el-col>
      </el-row>
    </el-card>

    <!-- 考勤状态分布 -->
    <el-card class="stats-card">
      <div slot="header">考勤状态分布</div>
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="dist-item normal">
            <div class="dist-value">{{ statusDist.normal }}</div>
            <div class="dist-label">正常</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="dist-item warning">
            <div class="dist-value">{{ statusDist.late }}</div>
            <div class="dist-label">迟到</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="dist-item warning">
            <div class="dist-value">{{ statusDist.early }}</div>
            <div class="dist-label">早退</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="dist-item danger">
            <div class="dist-value">{{ statusDist.absent }}</div>
            <div class="dist-label">缺卡</div>
          </div>
        </el-col>
      </el-row>
    </el-card>

    <!-- 员工考勤汇总表格 -->
    <el-card class="table-card">
      <div slot="header">
        <span>员工考勤明细</span>
        <span class="record-count">共 {{ total }} 名员工</span>
      </div>
      
      <el-table
        v-loading="loading"
        :data="tableData"
        stripe
        border
        style="width: 100%"
        :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
      >
        <el-table-column prop="userName" label="姓名" width="100" fixed />
        <el-table-column prop="userNo" label="工号" width="100" />
        <el-table-column prop="department" label="部门" width="100" />
        <el-table-column prop="userRole" label="角色" width="80">
          <template slot-scope="scope">
            <el-tag size="small">{{ getRoleName(scope.row.userRole) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="workDays" label="应出勤" width="70" align="center" />
        <el-table-column prop="actualDays" label="实际出勤" width="80" align="center" />
        <el-table-column prop="normalDays" label="正常" width="70" align="center">
          <template slot-scope="scope">
            <span class="text-success">{{ scope.row.normalDays }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="lateDays" label="迟到" width="70" align="center">
          <template slot-scope="scope">
            <span class="text-warning">{{ scope.row.lateDays || 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="earlyDays" label="早退" width="70" align="center">
          <template slot-scope="scope">
            <span class="text-warning">{{ scope.row.earlyDays || 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="absentDays" label="缺卡" width="70" align="center">
          <template slot-scope="scope">
            <span class="text-danger">{{ scope.row.absentDays || 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="leaveDays" label="请假" width="70" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.leaveDays || 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="makeupDays" label="补卡" width="70" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.makeupDays || 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="attendanceRate" label="出勤率" width="100" align="center">
          <template slot-scope="scope">
            <el-progress 
              :percentage="scope.row.attendanceRate || 0" 
              :color="getProgressColor(scope.row.attendanceRate)"
              :show-text="true"
              :stroke-width="10"
            />
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="120" show-overflow-tooltip />
      </el-table>
      
      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="pagination.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.pageSize"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        />
      </div>
    </el-card>
    </div>
  </div>
</template>

<script>
import * as checkinApi from '@/api/checkinApi.js'

export default {
  name: 'CheckinReport',
  data() {
    return {
      searchForm: {
        yearMonth: '',
        departmentId: '',
        userRole: '',
        keyword: ''
      },
      departmentList: [
        { id: '1', name: '行政部' },
        { id: '2', name: '市场部' },
        { id: '3', name: '培训部' },
        { id: '4', name: '后勤部' }
      ],
      summaryStats: {
        totalEmployees: 0,
        normalDays: 0,
        lateDays: 0,
        earlyDays: 0,
        absentDays: 0,
        leaveDays: 0
      },
      statusDist: {
        normal: 0,
        late: 0,
        early: 0,
        absent: 0
      },
      tableData: [],
      loading: false,
      pagination: {
        page: 1,
        pageSize: 20
      },
      total: 0
    }
  },
  created() {
    const now = new Date()
    this.searchForm.yearMonth = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`
    this.loadData()
  },
  methods: {
    goBack() {
      this.$router.push('/home/workbench')
    },
    async loadData() {
      this.loading = true
      try {
        const params = {
          ...this.searchForm,
          page: this.pagination.page,
          pageSize: this.pagination.pageSize
        }
        
        const result = await checkinApi.getCheckinSummaryList(params)
        
        if (result) {
          this.tableData = result.list || []
          this.total = result.total || 0
          
          if (result.summary) {
            this.summaryStats = result.summary
          }
          
          if (result.statusDist) {
            this.statusDist = result.statusDist
          }
        }
      } catch (e) {
        console.error('加载数据失败', e)
        this.$message.error('加载数据失败')
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.pagination.page = 1
      this.loadData()
    },
    handleReset() {
      const now = new Date()
      this.searchForm = {
        yearMonth: `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`,
        departmentId: '',
        userRole: '',
        keyword: ''
      }
      this.pagination.page = 1
      this.loadData()
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.loadData()
    },
    handlePageChange(val) {
      this.pagination.page = val
      this.loadData()
    },
    async handleExport() {
      try {
        const params = { ...this.searchForm }
        delete params.keyword
        const blob = await checkinApi.exportCheckinRecord(params)
        
        const url = window.URL.createObjectURL(new Blob([blob]))
        const link = document.createElement('a')
        link.href = url
        link.download = `考勤月报_${this.searchForm.yearMonth}.xlsx`
        link.click()
        window.URL.revokeObjectURL(url)
        
        this.$message.success('导出成功')
      } catch (e) {
        this.$message.error('导出失败')
      }
    },
    getRoleName(role) {
      const map = {
        'STAFF': '内勤',
        'COACH': '教练',
        'DRIVER': '司机',
        'SALES': '业务员',
        'FINANCE': '财务',
        'HR': '人事'
      }
      return map[role] || role
    },
    getProgressColor(rate) {
      if (!rate) return '#909399'
      if (rate >= 95) return '#67c23a'
      if (rate >= 80) return '#e6a23c'
      return '#f56c6c'
    }
  }
}
</script>

<style scoped>
.employee-manage-container {
  height: 100%;
  background: #f5f7fa;
  overflow: auto;
}

.page-header {
  background: #fff;
  padding: 16px 20px;
  border-bottom: 1px solid #e4e7ed;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.header-left i {
  font-size: 18px;
  cursor: pointer;
  color: #606266;
}

.header-left i:hover {
  color: #409eff;
}

.page-title {
  font-size: 18px;
  font-weight: bold;
  color: #303133;
}

.search-bar {
  display: flex;
  align-items: center;
  margin: 15px 20px;
  background: #fff;
  padding: 15px;
  border-radius: 4px;
}

.content-wrapper {
  margin: 0 20px;
  padding: 15px;
  background: #fff;
  border-radius: 4px;
}

.stats-card {
  margin-bottom: 20px;
  border-radius: 8px;
}

.stats-card .subtitle {
  margin-left: 12px;
  font-size: 12px;
  color: #909399;
  font-weight: normal;
}

.summary-item {
  text-align: center;
  padding: 16px;
  background: #f5f7fa;
  border-radius: 8px;
}

.summary-value {
  font-size: 28px;
  font-weight: bold;
  color: #303133;
}

.summary-value.normal { color: #67c23a; }
.summary-value.warning { color: #e6a23c; }
.summary-value.danger { color: #f56c6c; }
.summary-value.info { color: #909399; }

.summary-label {
  font-size: 12px;
  color: #909399;
  margin-top: 8px;
}

.dist-item {
  text-align: center;
  padding: 20px 16px;
  border-radius: 8px;
  color: #fff;
}

.dist-item.normal { background: linear-gradient(135deg, #67c23a 0%, #85ce61 100%); }
.dist-item.warning { background: linear-gradient(135deg, #e6a23c 0%, #ebb563 100%); }
.dist-item.danger { background: linear-gradient(135deg, #f56c6c 0%, #f78989 100%); }

.dist-value {
  font-size: 32px;
  font-weight: bold;
}

.dist-label {
  font-size: 14px;
  margin-top: 8px;
  opacity: 0.9;
}

.table-card {
  border-radius: 8px;
}

.card-header .record-count {
  margin-left: 12px;
  font-size: 12px;
  color: #909399;
  font-weight: normal;
}

.text-success { color: #67c23a; }
.text-warning { color: #e6a23c; }
.text-danger { color: #f56c6c; }

.pagination-container {
  margin-top: 20px;
  text-align: right;
  padding-bottom: 20px;
}
</style>
